import React, { useEffect, useState } from "react";
import { Box, Card, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import uuid from "react-uuid";
import { useDispatch } from "react-redux";

import ServiceTicket from "./panles/ServiceTicket";
import WDBox from "../../../MaterialComponents/WDBox";
import AppService from "../../../Configurations/Appservice";

import {
  dismissLoader,
  showLoader,
  updateScreenTitle,
} from "../../../LayoutContainers/AppLayout/redux/AppSlice";
import { APP_CONSTANTS } from "../../../Configurations/AppConstants";

const CustomerDashboard = () => {
  const [pendingTickets, setPendingTickets] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Dashboard"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    AppService.get("v1/dashboard/customerDash")
      .then((response) => {
        setPendingTickets(response.customerTickets || []);
        // setPendingPaymentItem(response.pendingPaymentItem || {});
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _navigateToPendingTickets = (ticket) => {
    navigate("/ADM-Ticket/pending-tickets", {
      state: {
        status: ticket.serviceName,
        screenType: APP_CONSTANTS.CUSTOMER_DASH,
      },
    });
  };

  const _renderPendingTickets = (ticket) => {
    return (
      <Grid item xs={12} md={3} key={uuid()}>
        <ServiceTicket ticket={ticket} onClick={() => _navigateToPendingTickets(ticket)} />
      </Grid>
    );
  };

  const EmptyTicketInfo = () => {
    return (
      <Box m={2}>
        <Card sx={{ p: 2 }}>
          <Typography>No Tickets Pending</Typography>
        </Card>
      </Box>
    );
  };

  return (
    <Box>
      {/* <Box>
        <Typography variant="subtitle2">Tickets</Typography>
      </Box> */}
      <Grid container spacing={1.5}>
        {pendingTickets && pendingTickets.map(_renderPendingTickets)}
        {!pendingTickets.length && <EmptyTicketInfo />}
      </Grid>
    </Box>
  );
};

export default CustomerDashboard;
